import { render } from "./ResolutionFilterView.vue?vue&type=template&id=140d10e8&scoped=true"
import script from "./ResolutionFilterView.vue?vue&type=script&lang=js"
export * from "./ResolutionFilterView.vue?vue&type=script&lang=js"

import "./ResolutionFilterView.vue?vue&type=style&index=0&id=140d10e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-140d10e8"]])

export default __exports__